import { styled, useTheme } from '@ori-ui/mui';
import { CheckoutImage } from '@ori/checkout-ui';
import useTestId from '@ori/testid-generator';

import type { PackagePictureProps } from '../types';

const ImageWrapper = styled('div')(({ theme }) => ({
  marginLeft: '4px',
  borderRadius: theme.shape.borderRadius,
}));

export function PackagePicture({ url, alt }: PackagePictureProps) {
  const { getTestId } = useTestId();
  const theme = useTheme();

  const testId = getTestId('package-icon');

  return (
    <CheckoutImage
      component={ImageWrapper}
      src={url ?? 'noImage'}
      alt={alt ?? 'package'}
      testId={testId}
      size="small"
      background={theme.palette.grey[100]}
      width="38px"
      height="38px"
    />
  );
}
